"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonDeskHeaderProvider = exports.CommonDeskHeaderDispatcherCtx = exports.CommonDeskHeaderValueCtx = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const query_string_1 = __importDefault(require("query-string"));
const react_1 = require("react");
const useContextAPI_1 = require("../hooks/useContextAPI");
const hangul = __importStar(require("hangul-js"));
const arroundSearch_1 = require("../modules/arroundSearch");
const recentSearchList_1 = require("../modules/recentSearchList");
let locationQuery = query_string_1.default.parseUrl(window.location.href).query["query"];
// static query 로직 추가
if (localStorage.getItem("is_static") === "true" &&
    localStorage.getItem("static_query") &&
    window.location.pathname.match(/^\/l-([a-zA-Z0-9\-]+)\.html$/)) {
    const staticQuery = localStorage.getItem("static_query");
    if (staticQuery) {
        try {
            const parsedQuery = JSON.parse(staticQuery);
            if (typeof parsedQuery === "string") {
                locationQuery = parsedQuery;
            }
        }
        catch (e) {
            console.warn("static_query parsing 실패:", e);
        }
    }
}
else if ((localStorage.getItem("is_static") === "false" &&
    localStorage.getItem("static_query")) ||
    !window.location.pathname.match(/^\/l-([a-zA-Z0-9\-]+)\.html$/)) {
    localStorage.removeItem("static_query");
}
exports.CommonDeskHeaderValueCtx = (0, useContextAPI_1.createValueContext)({
    open: false,
    focus: false,
    inputValue: locationQuery || "",
    autoValue: { rest: null, keyword: null },
    recentList: [],
    inputRef: { current: null },
    searcher: new hangul.Searcher(""),
    isInputExist: false,
});
exports.CommonDeskHeaderDispatcherCtx = (0, useContextAPI_1.createDispatcherContext)({
    setOpen: () => { },
    setFocus: () => { },
    setInputValue: () => { },
    setAutoValue: () => { },
    setRecentList: () => { },
    arroundSearch: arroundSearch_1.arroundSearch,
});
const CommonDeskHeaderProvider = ({ children, recentRefresh, setInner, }) => {
    // 항상 현재 URL에서 쿼리 파라미터를 직접 읽어옴
    const currentUrlQuery = query_string_1.default.parseUrl(window.location.href).query["query"];
    const [open, setOpen] = (0, react_1.useState)(false);
    const [focus, setFocus] = (0, react_1.useState)(false);
    // locationQuery 대신 currentUrlQuery를 우선 사용
    const [inputValue, setInputValue] = (0, react_1.useState)(currentUrlQuery || locationQuery || "");
    const [autoValue, setAutoValue] = (0, react_1.useState)({
        rest: null,
        keyword: null,
    });
    const [recentList, setRecentList] = (0, react_1.useState)((0, recentSearchList_1.getRecentSearchList)());
    const inputRef = (0, react_1.useRef)(null);
    const searcher = new hangul.Searcher(inputValue);
    const isInputExist = inputValue.length > 0;
    (0, react_1.useEffect)(() => {
        if (recentRefresh === true) {
            setRecentList((0, recentSearchList_1.getRecentSearchList)());
            // URL의 query 파라미터 가져오기
            const urlQuery = query_string_1.default.parseUrl(window.location.href).query["query"];
            // 현재 URL의 query 파라미터가 존재하고 현재 inputValue와 다르다면 업데이트
            if (urlQuery && urlQuery !== inputValue) {
                setInputValue(urlQuery);
            }
        }
        if (setInner) {
            setInner((inner) => ({ ...inner, recentRefresh: false }));
        }
    }, [recentRefresh]);
    const states = {
        open,
        focus,
        inputValue,
        autoValue,
        recentList,
        inputRef,
        searcher,
        isInputExist,
    };
    const dispatchers = {
        setOpen,
        setFocus,
        setInputValue,
        setAutoValue,
        setRecentList,
        arroundSearch: arroundSearch_1.arroundSearch,
    };
    return ((0, jsx_runtime_1.jsx)(exports.CommonDeskHeaderValueCtx.Provider, { value: states, children: (0, jsx_runtime_1.jsx)(exports.CommonDeskHeaderDispatcherCtx.Provider, { value: dispatchers, children: children }) }));
};
exports.CommonDeskHeaderProvider = CommonDeskHeaderProvider;
